export default __webpack_public_path__ + "static/media/huella.8d072c28.jpg";